// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Fetches audit events for a specific time record
 *
 * @param timeRecordKey - The unique key of the time record
 * @returns A promise that resolves to the audit events for the time record
 */
export async function getTimeRecordAuditEvents(timeRecordKey: string) {
  const url = `/v1/time-record/${timeRecordKey}/audit`;
  const response = await api.get(url);

  return await parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'TimeRecordAuditEvents',
    endpoint: url,
  });
}
